(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bambag-beige-banner"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bambag-beige-banner__animation').forEach((animation) => {
  const video = animation.querySelector('video');
  const button = animation.querySelector('button');
  if (!video || !button || animation.dataset.ready) return;
  animation.dataset.ready = 'true';
  const update = () => {
    button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    button.setAttribute('aria-pressed', String(video.paused));
  };
  video.muted = true;
  video.addEventListener('play', update);
  video.addEventListener('pause', update);
  button.addEventListener('click', () => {
    if (video.paused) video.play().catch(update);
    else video.pause();
  });
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(update);
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bambag-promo-marquee"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bambag-marquee').forEach((bar) => {
  const button = bar.querySelector('button');
  if (!button || bar.dataset.ready) return;
  bar.dataset.ready = 'true';
  let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const update = () => {
    bar.classList.toggle('is-paused', paused);
    bar.classList.toggle('is-playing', !paused);
    button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    button.setAttribute('aria-pressed', String(paused));
  };
  button.addEventListener('click', () => { paused = !paused; update(); });
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["client-comments"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.client-comments__details').forEach((details) => {
  if (details.querySelector('[role="status"], .errors')) details.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
